module.exports = __webpack_public_path__ + "img/icon1.a83d83d4.png";